<ngx-spinner></ngx-spinner>
<section id="front_wrap">
  <div class="auth-language-selector"><app-language-selector></app-language-selector></div>
  <section id="connect_page">
    <div id="connect_title">
      <ng-container *ngIf="text_login">
        <p>{{'auth.forgotPasswordTitle' | translate}}</p>
      </ng-container>
      <ng-container *ngIf="text_new_password">
        <p>{{'auth.newPassword' | translate}}</p>
      </ng-container>

    </div>
    <div id="connect_content">
      <form>
        <ng-container *ngIf="text_login">
          <input type="email" [placeholder]="'auth.yourIdentifier' | translate" [(ngModel)]="email_send" [ngModelOptions]="{standalone: true}">
          <button class="blue_btn" type="button" color="accent" (click)="send_new_password()">{{'common.send' | translate}}</button>
          <p style="margin-top: 25px"><a href="/">&lt;&lt; {{'auth.login' | translate}}</a></p>
        </ng-container>
        <ng-container *ngIf="text_new_password">
          <input class="mb-0" type="password" [placeholder]="'auth.newPassword' | translate" [(ngModel)]="new_password" [ngModelOptions]="{standalone: true}">
          <div class="col-md-12 mt-3 mb-3">
            <p [ngClass]="{'text-danger': isPasswordInvalid}" class="text-danger fw-bold ml-2 mt-2">
              {{'auth.passwordRules' | translate}}
            </p>
          </div>
          <button class="blue_btn" type="button" color="accent" (click)="change_password()">{{'common.change' | translate}}</button>
          <p style="margin-top: 25px"><a href="/">&lt;&lt; {{'auth.login' | translate}}</a></p>
        </ng-container>
      </form>
    </div>
    <div id="connect_legal">
      <p>Institut PASTEUR - par <strong>Kaptitude</strong> - 2021</p>

    </div>
  </section>
</section>
